// extracted by mini-css-extract-plugin
module.exports = {"mainImg":"ImageBreak_mainImg__n1Kkz"};